import { render, staticRenderFns } from "./DefaultSummary.vue?vue&type=template&id=56ca680a"
import script from "./DefaultSummary.vue?vue&type=script&lang=ts"
export * from "./DefaultSummary.vue?vue&type=script&lang=ts"
import style0 from "./DefaultSummary.vue?vue&type=style&index=0&id=56ca680a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports